export default __webpack_public_path__ + "static/media/BGnews.e82469ef.png";